import React, { FC, useRef, useState } from 'react';
import Subheading from '../font/Subheading';
import { TwitterPicker } from 'react-color';
import styled from 'styled-components';

import ColumnItem from '../layout/ColumnItem';
import Row from '../layout/Row';
import Spacer from '../layout/Spacer';
import RadioButton from '../radio/RadioButton';
import RadioButtonWrapper from '../radio/RadioButtonWrapper';
import { useAppDispatch, useAppSelector } from '../../redux/redux.hooks';
import { changeWidgetBackground } from '../../reducers/fit.quiz.widget.reducer';
import RadioButtonContent from '../radio/RadioButtonContent';
import { PreviewContainer } from './PreviewContainer';
import SectionContainer from './SectionContainer';
import { P } from '../font/Parargraph';
import { useClickOutside } from '../../hooks/use.click.outside';

type WidgetBackgroundProps = {};

const WidgetBackground: FC<WidgetBackgroundProps> = () => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.widgetReducer);
  const backgroundColorRef = useRef<HTMLDivElement>(null);
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false);

  useClickOutside(backgroundColorRef, () => setShowColorPicker(false));

  const renderSettings = () => (
    <>
      <Row>
        <ColumnItem>
          <s-heading fontSize='large'>Customize the background of the widget</s-heading>
          <Spacer height={8} />
          <P>
            Change the background color of the widget to make it in line with
            the style guide of the customer's store
          </P>
        </ColumnItem>
      </Row>
      <Spacer height={24} />
      <Row>
        <ColumnItem>
          <Subheading>Widget background</Subheading>
          <Spacer height={4} />
          <Row>
            <RadioButtonWrapper>
              <RadioButton
                groupName='widget-background'
                value='black'
                checked={
                  data.widgetBackground.toLowerCase() ===
                  '#0c0706'.toLowerCase()
                }
                onClick={() => dispatch(changeWidgetBackground('#0c0706'))}
                content={() => (
                  <RadioButtonContent customBackground='#0c0706' />
                )}
              />
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                groupName='widget-background'
                value='white'
                checked={
                  data.widgetBackground.toLowerCase() ===
                  '#FFFFFF'.toLowerCase()
                }
                onClick={() => dispatch(changeWidgetBackground('#FFFFFF'))}
                content={() => (
                  <RadioButtonContent
                    customBackground='#ffffff'
                    style={{ borderColor: '#e7e5e5' }}
                  />
                )}
              />
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <RadioButton
                groupName='widget-background'
                value='blue'
                checked={
                  data.widgetBackground.toLowerCase() ===
                  '#5673C0'.toLowerCase()
                }
                onClick={() => dispatch(changeWidgetBackground('#5673C0'))}
                content={() => (
                  <RadioButtonContent customBackground='#5673C0' />
                )}
              />
            </RadioButtonWrapper>
            <RadioButtonWrapper>
              <s-button onClick={() => setShowColorPicker(!showColorPicker)}>
                Custom
              </s-button>
            </RadioButtonWrapper>
          </Row>
          {showColorPicker && (
            <>
              <Spacer height={12} />
              <Row ref={backgroundColorRef}>
                <TwitterPicker
                  triangle='top-right'
                  color={data.ctaStyle.fontColor}
                  onChangeComplete={(value) =>
                    dispatch(changeWidgetBackground(value.hex))
                  }
                />
              </Row>
            </>
          )}
        </ColumnItem>
      </Row>
    </>
  );

  const renderPreview = () => {
    const style = {
      backgroundColor: data.widgetBackground,
    };
    return (
      <PreviewContainer>
        <WidgetPreviewContainer style={style} />
      </PreviewContainer>
    );
  };
  return (
    <SectionContainer
      renderSettingsForm={renderSettings}
      renderPreview={renderPreview}
    />
  );
};

export default WidgetBackground;

const WidgetPreviewContainer = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
`;
